export const STATIC_JOBS_VERIFIED_AT = 'September 29, 2026';

export const STATIC_JOBS = [
  {
    id: '853530',
    title: 'RN Medical/Surgical Tele-Registered Nurse',
    profession: 'Registered Nurse',
    specialty: 'Med/Surg Tele',
    city: 'Rochester',
    state: 'NY',
    weeklyGross: 2101,
    employmentType: 'Contract',
    shift: null,
    sourceUrl: 'https://careteamsolutions.staffingreferrals.com/j/853530?recruiter_id=2672076',
    applyUrl: 'https://careteamsolutions.staffingreferrals.com/j/853530/applications/new?recruiter_id=2672076',
  },
  {
    id: '1703433',
    title: 'Registered Nurse-Medical-Surgical',
    profession: 'Registered Nurse',
    specialty: 'Medical-Surgical',
    city: 'Albany',
    state: 'NY',
    weeklyGross: 2218,
    employmentType: 'Contract',
    shift: null,
    sourceUrl: 'https://careteamsolutions.staffingreferrals.com/j/1703433/applications/new?recruiter_id=2672076',
    applyUrl: 'https://careteamsolutions.staffingreferrals.com/j/1703433/applications/new?recruiter_id=2672076',
  },
  {
    id: '1703346',
    title: 'Registered Nurse-Intensive Care Unit',
    profession: 'Registered Nurse',
    specialty: 'ICU',
    city: 'Newark',
    state: 'NY',
    weeklyGross: 2172,
    employmentType: 'Contract',
    shift: null,
    sourceUrl: 'https://careteamsolutions.staffingreferrals.com/j/1703346?recruiter_id=2672076',
    applyUrl: 'https://careteamsolutions.staffingreferrals.com/j/1703346/applications/new?recruiter_id=2672076',
  },
  {
    id: '1703324',
    title: 'Registered Nurse-Post-Anesthesia',
    profession: 'Registered Nurse',
    specialty: 'PACU',
    city: 'Rochester',
    state: 'NY',
    weeklyGross: 2440,
    employmentType: 'Contract',
    shift: null,
    sourceUrl: 'https://careteamsolutions.staffingreferrals.com/j/1703324?recruiter_id=2672076',
    applyUrl: 'https://careteamsolutions.staffingreferrals.com/j/1703324/applications/new?recruiter_id=2672076',
  },
  {
    id: '1701424',
    title: 'Pharmacist-Pharmacy',
    profession: 'Pharmacy',
    specialty: 'Pharmacist',
    city: 'Wellsville',
    state: 'NY',
    weeklyGross: 2724,
    employmentType: 'Contract',
    shift: null,
    sourceUrl: 'https://careteamsolutions.staffingreferrals.com/j/1701424?recruiter_id=2672076',
    applyUrl: 'https://careteamsolutions.staffingreferrals.com/j/1701424/applications/new?recruiter_id=2672076',
  },
  {
    id: '1700087',
    title: 'Registered Nurse-Telemetry',
    profession: 'Registered Nurse',
    specialty: 'Telemetry',
    city: 'Rochester',
    state: 'NY',
    weeklyGross: 2101,
    employmentType: 'Contract',
    shift: null,
    sourceUrl: 'https://careteamsolutions.staffingreferrals.com/j/1700087?recruiter_id=2672076',
    applyUrl: 'https://careteamsolutions.staffingreferrals.com/j/1700087/applications/new?recruiter_id=2672076',
  },
  {
    id: '1699902',
    title: 'Registered Nurse-Operating Room',
    profession: 'Registered Nurse',
    specialty: 'Operating Room',
    city: 'Glens Falls',
    state: 'NY',
    weeklyGross: 2101,
    employmentType: 'Contract',
    shift: null,
    sourceUrl: 'https://careteamsolutions.staffingreferrals.com/j/1699902?recruiter_id=2672076',
    applyUrl: 'https://careteamsolutions.staffingreferrals.com/j/1699902/applications/new?recruiter_id=2672076',
  },
  {
    id: '1111331',
    title: 'MRI Tech Radiology / Cardiology',
    profession: 'Allied Health',
    specialty: 'MRI Tech',
    city: 'Easley',
    state: 'SC',
    weeklyGross: 2465,
    employmentType: 'Contract',
    shift: null,
    sourceUrl: 'https://careteamsolutions.staffingreferrals.com/j/1111331/applications/new?recruiter_id=3573591',
    applyUrl: 'https://careteamsolutions.staffingreferrals.com/j/1111331/applications/new?recruiter_id=3573591',
  },
  {
    id: '1111328',
    title: 'CVOR Registered Nurse',
    profession: 'Registered Nurse',
    specialty: 'CVOR',
    city: 'Indianapolis',
    state: 'IN',
    weeklyGross: 2621,
    employmentType: 'Contract',
    shift: null,
    sourceUrl: 'https://careteamsolutions.staffingreferrals.com/j/1111328/applications/new?recruiter_id=3573591',
    applyUrl: 'https://careteamsolutions.staffingreferrals.com/j/1111328/applications/new?recruiter_id=3573591',
  },
  {
    id: '1111283',
    title: 'Temp - Registered Nurse (RN) - Cath Lab (Days)',
    profession: 'Registered Nurse',
    specialty: 'Cath Lab',
    city: 'Lawton',
    state: 'OK',
    weeklyGross: 2076,
    employmentType: 'Contract',
    shift: 'Days',
    sourceUrl: 'https://careteamsolutions.staffingreferrals.com/j/1111283/applications/new?recruiter_id=3573591',
    applyUrl: 'https://careteamsolutions.staffingreferrals.com/j/1111283/applications/new?recruiter_id=3573591',
  },
];
